import React, { Component } from 'react';

const importAll = (r) => {
    return r.keys().map(r);
};

const images = importAll(
    require.context('../pictures', false, /\.(png)$/)
);

class PictureDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedPicture: images.length > 0 ? images[0] : null, // Set the first picture as default
        };
    }

    handlePictureChange = (event) => {
        const selectedPicture = event.target.value;

        this.setState({
            selectedPicture,
        });
    };

    extractClassName = (imagePath) => {
        // Split the image path by '/' and select the last part
        const parts = imagePath.split('/');
        const className = parts[parts.length - 1];

        // Remove the file extension (e.g., .png)
        const classNameWithoutExtension = className.split('.')[0];

        return classNameWithoutExtension;
    };

    render() {
        return (
            <div style={{ fontFamily: 'Arial', textAlign: 'center', padding: '20px', backgroundColor: 'transparent' }}>
                <h1 style={{ fontSize: '24px', color: '#333', marginBottom: '20px' }}>Class Word Cloud</h1>
                <select
                    id="pictureDropdown"
                    value={this.state.selectedPicture || ''}
                    onChange={this.handlePictureChange}
                    style={{
                        fontSize: '16px',
                        padding: '10px',
                        width: '200px', // Adjust the width as needed
                        borderRadius: '10px',
                        border: '2px solid #1E90FF',
                        background: 'transparent', // Set background to transparent
                        textAlign: 'center',
                    }}
                >
                    {images.map((image, index) => (
                        <option key={index} value={image}>
                            {this.extractClassName(image)}
                        </option>
                    ))}
                </select>

                {this.state.selectedPicture && (
                    <div style={{ marginTop: '20px' }}>
                        <img
                            src={this.state.selectedPicture}
                            alt="Selected Picture"
                            style={{ maxWidth: '300px', borderRadius: '5px', boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)' }}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default PictureDropdown;
